export default __webpack_public_path__ + "aba3f7ebf7be005b2f352e396833dfec.svg";